import React, { useState } from "react";
import { AccordionItemProps } from "./types";

const AccordionItem: React.FC<AccordionItemProps> = ({ gallery, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-brown-50/20 cursor-pointer relative [&>div]:hover:opacity-100">
      <div className={`transition-opacity text-black ${open ? "opacity-100" : "opacity-80"}`}>
        <button
          className="relative flex-1 mr-6 text-left flex justify-between items-center w-full [&>div>svg]:fill-white hover:[&>div>svg]:fill-brown-100 hover:[&>div>h3]:text-brown-100 cursor-pointer"
          onClick={() => setOpen(!open)}
        >
          <div className="flex-1 mr-6">
            {gallery.title && (
              <h3 className={`mt-6 md:mt-8 mb-4 text-2xl md:text-3xl font-extrabold font-serif ${open ? 'text-brown-100' : 'text-white'}`}>
                {gallery.title}
              </h3>
            )}
            {gallery.text && (
              <div className="font-light text-lg md:text-xl font-sans mb-6 md:mb-8 text-white">
                {gallery.text}
              </div>
            )}
          </div>
          <div className="w-[20px] h-[20px] md:w-[40px] md:h-[40px]">
            {open ? (
              <svg
                version="1.1"
                viewBox="0 0 512 512"
                className={`${!open ? `fill-black` : `fill-brown-100`}`}
              >
                <rect
                  className="transition-all"
                  height="64"
                  width="384"
                  x="64"
                  y="224"
                />
              </svg>
            ) : (
              <svg
                version="1.1"
                viewBox="0 0 512 512"
                className={`${!open ? `fill-black` : `fill-brown-100`}`}
              >
                <polygon
                  className="transition-all"
                  points="448,224 288,224 288,64 224,64 224,224 64,224 64,288 224,288 224,448 288,448 288,288 448,288 "
                />
              </svg>
            )}
          </div>
        </button>
      </div>
      <div className={`mb-6 md:mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 gap-y-3 lg:gap-8 lg:gap-y-8 ${!open && `hidden`}`}>
        {children}
      </div>
    </div>
  );
};

export default AccordionItem